import { PathOptions } from "leaflet";

/**
 * Mesorregião mapping for each Região Imediata
 * Based on IBGE's traditional mesorregião classification
 */
const mesorregioesMap: Record<string, { nome: string; codigo: string }> = {
  "260001": { nome: "Metropolitana do Recife", codigo: "2605" }, // Recife
  "260002": { nome: "Mata Pernambucana", codigo: "2604" }, // Goiana - Timbaúba (Mata Setentrional)
  "260003": { nome: "Mata Pernambucana", codigo: "2604" }, // Palmares (Mata Meridional)
  "260004": { nome: "Agreste Pernambucano", codigo: "2603" }, // Limoeiro (Médio Capibaribe)
  "260005": { nome: "Mata Pernambucana", codigo: "2604" }, // Vitória de Santo Antão
  "260006": { nome: "Mata Pernambucana", codigo: "2604" }, // Carpina (Mata Setentrional)
  "260007": { nome: "Mata Pernambucana", codigo: "2604" }, // Barreiros - Sirinhaém (Mata Meridional)
  "260008": { nome: "Agreste Pernambucano", codigo: "2603" }, // Surubim (Alto Capibaribe)
  "260009": { nome: "Agreste Pernambucano", codigo: "2603" }, // Caruaru (Vale do Ipojuca)
  "260010": { nome: "Agreste Pernambucano", codigo: "2603" }, // Garanhuns
  "260011": { nome: "Sertão Pernambucano", codigo: "2601" }, // Arcoverde (Sertão do Moxotó)
  "260012": { nome: "Agreste Pernambucano", codigo: "2603" }, // Belo Jardim - Pesqueira (Vale do Ipojuca)
  "260013": { nome: "Sertão Pernambucano", codigo: "2601" }, // Serra Talhada (Pajeú)
  "260014": { nome: "Sertão Pernambucano", codigo: "2601" }, // Afogados da Ingazeira (Pajeú)
  "260015": { nome: "São Francisco Pernambucano", codigo: "2602" }, // Petrolina
  "260016": { nome: "Sertão Pernambucano", codigo: "2601" }, // Araripina
  "260017": { nome: "Sertão Pernambucano", codigo: "2601" }, // Salgueiro
  "260018": { nome: "Mata Pernambucana", codigo: "2604" }, // Escada - Ribeirão (Mata Meridional)
};

/**
 * Color mapping by Mesorregião
 * Gradient: Dark Green (Coast) → Hot Orange (Interior/Sertão)
 */
const mesorregiaoColors: Record<string, string> = {
  "2605": "#0a5c0a", // Metropolitana do Recife - Darkest Green
  "2604": "#2d8b2d", // Mata Pernambucana - Medium Green
  "2603": "#8bbd3a", // Agreste Pernambucano - Yellow-Green
  "2601": "#e69500", // Sertão Pernambucano - Orange
  "2602": "#ff4500", // São Francisco Pernambucano - Hot Orange
};

/**
 * Style for regioes_imediatas_pe layer
 * Each region is colored based on its mesorregião
 * Colors form a gradient from dark green (coast) to hot orange (interior)
 */
export const regioes_imediatas_pe = (feature: any): PathOptions => {
  const cd_rgi = feature.properties?.cd_rgi;

  // Get mesorregião for this region
  const mesorregiao = mesorregioesMap[cd_rgi];

  // Enrich feature properties with mesorregião data
  if (mesorregiao && feature.properties) {
    feature.properties.mesorregiao = mesorregiao.nome;
    feature.properties.cd_mesorregiao = mesorregiao.codigo;
  }

  // Get color based on mesorregião, default to gray if not found
  const fillColor = mesorregiao
    ? mesorregiaoColors[mesorregiao.codigo]
    : "#808080";

  return {
    color: "#000000",
    weight: 2,
    opacity: 0.8,
    fillColor: fillColor,
    fillOpacity: 0.6,
  };
};

